import(/* webpackMode: "eager" */ "/vercel/path0/app/(routes)/Vision/page.js");
